import { __read } from 'tslib';
import React__default from 'react';
import { useCurrentUser } from '@invitae/cms-blocks';
import { useCountryLocationPrefix } from '@invitae/nucleobase-engine-contentful';

var currentUserButtonPath = {
    patient: '/patients/dashboard',
    physician: '/hcp',
};
var useUserButtonConfig = function (_a) {
    var myAccountText = _a.myAccountText, signInText = _a.signInText;
    var currentUser = useCurrentUser();
    var addCountryCodePrefix = useCountryLocationPrefix().addCountryCodePrefix;
    if (currentUser && currentUser.role) {
        return {
            path: currentUserButtonPath[currentUser.role],
            text: myAccountText,
        };
    }
    return {
        path: addCountryCodePrefix('profile/signin'),
        text: signInText,
    };
};
var useMenuStateControl = function () {
    var _a = __read(React__default.useState(), 2), activeElementId = _a[0], setActiveElementIdFn = _a[1];
    var setActiveElementId = React__default.useCallback(function (newActiveElementId) {
        return setActiveElementIdFn(function (prevActiveElementId) {
            return prevActiveElementId === newActiveElementId ? undefined : newActiveElementId;
        });
    }, []);
    return { activeElementId: activeElementId, setActiveElementId: setActiveElementId };
};

export { useMenuStateControl, useUserButtonConfig };
//# sourceMappingURL=NavigationHeader.hooks.esm.js.map
